export const RestoreDown = (
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M5 5H19V19H12V21H19C20.11 21 21 20.1 21 19V5C21 3.9 20.11 3 19 3H5C3.9 3 3 3.9 3 5V12H5V5ZM10 21V19H6.41L16.24 9.17L14.83 7.76L5 17.59V14H3V21H10Z" fill="var(--YW_Theme_Header_CompactView_Icon_Color)"/>
</svg>
)